import { render, staticRenderFns } from "./VenueList.vue?vue&type=template&id=5b1ba59a&scoped=true&"
import script from "./VenueList.vue?vue&type=script&lang=js&"
export * from "./VenueList.vue?vue&type=script&lang=js&"
import style0 from "./VenueList.vue?vue&type=style&index=0&id=5b1ba59a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1ba59a",
  null
  
)

export default component.exports